import { render, staticRenderFns } from "./edit-contacts.vue?vue&type=template&id=580a630e&"
import script from "./edit-contacts.vue?vue&type=script&lang=js&"
export * from "./edit-contacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports